export default __webpack_public_path__ + "static/media/screen1.1cd2de8d.png";